import React, { useState, useEffect } from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import OutlinedInput from "@mui/material/OutlinedInput"
import { forgotPassword } from "../../redux/Slice/forgotSlice"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "sonner"
import logo from "../../assets/images/logo.jpeg"
import { Box, FormLabel } from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { setLoading } from "../../redux/Slice/loaderSlice"

export default function ForgotPassword({ open, handleClose }) {
  const [email, setEmail] = useState("")
  const dispatch = useDispatch()


  const handleSubmit = (event) => {
    event.preventDefault()
    dispatch(setLoading(true));
    if (email) {
      dispatch(forgotPassword(email))
        .then(() => {
          dispatch(setLoading(false));
          handleDialogClose()
        })
        .catch((err) => {
          dispatch(setLoading(false));
          console.error("Failed to Send Password Reset Link. Please Try Again 😒")
        })
    }
    // console.log(error)
  }

  const handleDialogClose = () => {
    setEmail("")
    handleClose()
  }



  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      PaperProps={{
        component: "form",
        onSubmit: handleSubmit,
        sx: { backgroundColor: "white", backgroundImage: "none", width: "500px" },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, paddingTop: 3 }}>
        <img src={logo} alt="Forgot Password Icon" style={{ width: "350px", height: "90px" }} />
      </Box>
      <DialogTitle sx={{ color: "black" }}>Forgot Password</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          width: "100%",
        }}
      >
        <DialogContentText>No warries! Enter your email and we will send you a reset link.</DialogContentText>
        <FormLabel sx={{ color: "black", fontSize: "15px", fontWeight: "600", mb: 0 }}>Email id</FormLabel>
        <OutlinedInput
          autoFocus
          required
          margin="dense"
          id="email"
          name="email"
          label="Email address"
          placeholder="info@builderPluss.com"
          type="email"
          fullWidth
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{
            backgroundColor: "white",
            color: "black",
          }}
        />
      </DialogContent>
      <DialogActions sx={{ flexDirection: "column", gap: 1, px: 3, pb: 3 }}>
        <Button
          type="submit"
          fullWidth
          sx={{
            backgroundColor: "#2FB354",
            color: "white",
            "&:hover": { backgroundColor: "#2FB354" },
          }}
        >
          Continue
        </Button>

        <Button
          onClick={handleDialogClose}
          style={{
            textTransform: "none",
            padding: 0,
            color: "#007bff",
            background: "none",
            boxShadow: "none",
            cursor: "pointer",
            display: "flex",
          }}
        >
          <ArrowBackIcon style={{ marginRight: 8 }} />
          Back To Login
        </Button>
      </DialogActions>
    </Dialog>
  )
}
